import { Controller } from "@hotwired/stimulus"

// Select-all for the rows a search leaves visible, a clear, and a running count of the ticked boxes.
export default class extends Controller {
  static targets = ["box", "count"]
  static values = { label: String }

  connect() {
    this.update()
  }

  selectVisible() {
    this.boxTargets.forEach((box) => {
      if (box.closest("tr, li")?.classList.contains("hidden") || box.closest("details:not([open])")) return
      box.checked = true
    })
    this.update()
  }

  clear() {
    this.boxTargets.forEach((box) => { box.checked = false })
    this.update()
  }

  update() {
    const count = this.boxTargets.filter((box) => box.checked).length
    this.countTargets.forEach((el) => { el.textContent = this.labelValue.replace("%{count}", count) })
    this.element.dispatchEvent(new Event("input", { bubbles: true }))
  }
}
